<template>
  <div />
</template>

<script>
import LoginService from "./LoginService";
export default {
  mixins: [LoginService],
  data() {
    return {
      usuarioPapel: null
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.configurarDados();
      this.iniciarLogin();
    },
    /**
     * Função que pega a querystring e retorna os dados para a ação de login
     * @return { { "authCode": String, "codigoUnimed": String } }
     */
    configurarDados() {
      let authCode, codigoUnimed;
      const { code, state } = this.$route.query;
      authCode = code;
      const params = new URLSearchParams(state);
      codigoUnimed = params.get("codigoUnimed");
      return { authCode, codigoUnimed };
    },
    iniciarLogin() {
      this.$store.commit("setLoadingModal", true);
      this.login().then(() => {
        this.informacoesUsuario().then(() => {
          this.permissoesUsuario().then(() => {
            this.$router.push("/home");
            this.$store.commit("setLoadingModal", false);
            this.$emit("mostrar-header");
          });
        });
      });
    },
    /**
     * Método que é usado para fazer a ação de login, aqui o tokenBearer é salvo tanto na store do vuex quanto na localstorage
     * @return { Promise<null> }
     */
    login() {
      return new Promise(resolve => {
        this.getLogin(this.configurarDados()).then(res => {
          this.$store.commit("setTokenBearer", res.headers.authorization);
          resolve();
        });
      });
    },
    /**
     * Método que recupera as informações do usuário, salva tanto na store do vuex quanto na localstorage
     * @return { Promise<null> }
     */
    informacoesUsuario() {
      return new Promise(resolve => {
        this.$store.dispatch("getInformacaoUsuario").then(resUsuario => {
          this.usuarioPapel = resUsuario.data.papel;
          this.$store.commit("setUsuarioCompleto", resUsuario.data);
          this.$store.commit("recuperarDadosUsuario");
          resolve();
        });
      });
    },
    /**
     * Método que recupera as permissões do usuário, salva tanto na store do vuex quanto na localstorage
     * @return { Promise<null> }
     */
    permissoesUsuario() {
      return new Promise(resolve => {
        this.$store.dispatch("getPermissoesUsuario").then(resPermissoes => {
          let objTelas = { telas: [...resPermissoes.data.telas] };
          if (this.usuarioPapel.descricao === "UBGestorGestaoRedes") {
            objTelas.telas.push("RELATORIO_PRODUTIVIDADE");
          }
          this.$store.commit("setUsuarioPermissoes", objTelas);
          resolve();
        });
      });
    }
  }
};
</script>

<style></style>
\
